/*
* General custom scripts
**/
import 'lazysizes';
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";

jQuery(document).ready(function () {
    bodyScrolled();
    bodyPadding();
});
jQuery(window).scroll(function () {
    bodyScrolled();
});
jQuery(window).resize(function () {
    setTimeout(bodyPadding, 200)
});


function bodyPadding() {
    var headerHeight = jQuery('.page-header').outerHeight();
    jQuery('body:not(.page-template-page-mattress-selector)').css('padding-top', headerHeight);
}

function bodyScrolled() {
    if (jQuery(window).scrollTop() > 10) {
        jQuery('body').addClass('is-scrolled');
    } else {
        jQuery('body').removeClass('is-scrolled');
    }
}

jQuery('.select2-init').select2({
    minimumResultsForSearch: -1,
    placeholder: 'Select an option',
    // theme: 'classic'
});


const animations = document.querySelectorAll('.animation');
const observer = new IntersectionObserver(entries => {
    // Loop over the entries
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('animation--done');
        }
    });
});

animations.forEach(sections => {
    observer.observe(sections);
});
